import * as Sentry from '@sentry/nextjs';
import wait from '@utils/wait';

const keyPrefixDefault = 'webCustom';
const retries = 10;

const pushToDataLayer = async function (payload: object, retry: number = 0) {
    if (!window.dataLayer) {
        await wait(100);
        retry < retries && (await pushToDataLayer(payload, retry + 1));
        return;
    }

    window.dataLayer.push(payload);
};

export async function dataLayerEmit(
    eventName: string,
    values: object = {},
    keyPrefix: string = keyPrefixDefault,
) {
    if (!eventName) {
        return;
    }

    try {
        await pushToDataLayer({event: keyPrefix.concat(eventName), ...values});
    } catch (error) {
        console.error('Error emitting data layer event:', error);
        Sentry.captureException(error);
    }
}

export async function dataLayerPush(
    key: string,
    value: string | number | undefined,
    keyPrefix: string = keyPrefixDefault,
) {
    if (!key) {
        return;
    }

    await pushToDataLayer({[keyPrefix.concat(key)]: value});
}
